export const subscriptionPlanConstants = {
  FETCH_SUBSCRIPTION_PLAN: 'FETCH_SUBSCRIPTION_PLAN',
  FETCH_SUBSCRIPTION_PLAN_BY_ID: 'FETCH_SUBSCRIPTION_PLAN_BY_ID',
  NEW_GET_SUBSCRIPTION_PLANS: 'NEW_GET_SUBSCRIPTION_PLANS',
};
